import { createStore } from 'vuex';

const store = createStore({
    state () {
      return {
          lang: 'ua',
          postId: null,
          projectId: null,
          page: 'main',
          menuActive: false,
          contactsActive:false
      }
    },
    mutations: {
        setLang(state, lang) {
            state.lang = lang
        },
        setRoute(state, route) {
            state.page = route
            state.menuActive = false
        },
        setPost(state, post){
            state.postId = post
            state.page = 'post'
        },
        clearPost(state, backRoute){
            state.postId = null
            state.page = backRoute
        },
        setProject(state, project){
            state.projectId = project
            state.page = 'project'
        },
        clearProject(state,backRoute){
            state.projectId = null
            state.page = backRoute
        },
        toggleContacts(state){
            state.contactsActive = !state.contactsActive
            state.menuActive = false
        },
        toggleMenu(state){
            state.menuActive = !state.menuActive
        }
    }
})

export default store